import cn from '../utils/cn';
import { LOADER_STYLE } from './KoobLoader';

// The logo pack's AI assistant mark (svg/assistant): the "chat B", a navy top
// half over a white bottom half with a tail, on an orange tile or circle.
// For the assistant only, never as the app icon.
const TOP = 'M28 18H54A13 13 0 0 1 54 44H28Z';
const BOTTOM = 'M28 48H60A13 13 0 0 1 60 74H38L28 82Z';
// The pale orange track of the thinking mark (not in the brand palette).
const TRACK = '#F9A659';

type KoobAssistantIconProps = {
  /** Width and height in px. */
  size?: number;
  /** The circle avatar instead of the rounded tile. */
  round?: boolean;
  /** The pack's koob-assistant-thinking: the B fills as Koob's loader, while
   * the assistant works. Holds still under prefers-reduced-motion. */
  thinking?: boolean;
  className?: string;
};

/** The AI assistant's icon and avatar; decorative, so hidden from screen
 * readers: say what it stands for in text beside it. */
export default function KoobAssistantIcon({
  size = 32,
  round = false,
  thinking = false,
  className,
}: KoobAssistantIconProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      aria-hidden
      className={cn('inline-block shrink-0', className)}
    >
      {thinking && <style>{LOADER_STYLE}</style>}
      <rect
        width="100"
        height="100"
        rx={round ? 50 : 22}
        className="fill-k-orange"
      />
      {thinking ? (
        <>
          <path d={TOP} fill={TRACK} />
          <path className="koob-loader-fill fill-k-h" d={TOP} />
          <path d={BOTTOM} fill={TRACK} />
          <path
            className="koob-loader-fill koob-loader-late fill-white"
            d={BOTTOM}
          />
        </>
      ) : (
        <>
          <path className="fill-k-h" d={TOP} />
          <path className="fill-white" d={BOTTOM} />
        </>
      )}
    </svg>
  );
}
